/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React, { useEffect, useState } from 'react'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { pucSerive } from '@services/pucService'
import WidgetModal from '@components/MainWidget/common/widgetModal'
import { PUC_API_ERROR, PUC_DETAIL, PUC_HEADING, PUC_WIDGET } from '@components/MainWidget/common/commonConstants'
import AppDownloadSection from '@components/MainWidget/common/appDownloadSection'
import { commonWidgetConfig } from '@components/MainWidget/common/commonWidgetConfig'
import { validatePUC } from '@components/MainWidget/common/helper'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { getPucDataWithFallback } from '@factories/getPucDataWithFallback'
import PucShimmer from './pucShimmer'
import style from './pucWidget.module.scss'

interface UserData {
  phone: string | number
}
interface PucData {
  expiry_date?: string;
}

const PucWidgetModal = ({
  vehicleData,
  regNo,
  setWidgetModal,
  KeyFeatures,
  segmentEventCommonProperties,
  phone,
  userData,
  setRegNo,
  setVehicleData
}: {
  vehicleData: object
  regNo: string
  setWidgetModal: Function
  KeyFeatures: any
  segmentEventCommonProperties: object
  phone: string | number
  userData?: UserData
  setRegNo: Function
  setVehicleData: object
}) => {
  const [pucData, setPucData] = useState<PucData>({})
  const [isPucExpired, setIsPucExpired] = useState<boolean>(false)
  const [isFetching, setIsFetching] = useState<boolean>(true)
  useEffect(() => {
    pucSerive(regNo)
      .then(response => {
        setPucData(response)
      })
      .catch(error => {
        console.error(PUC_API_ERROR, error)
      })
      .finally(() => {
        setIsFetching(false) // This will always run after the promise settles (whether it resolves or rejects)
      })
  }, [])
  useEffect(() => {
    if (pucData) {
      validatePUC({ pucData, setIsPucExpired })
    }
  }, [pucData])

  const pucDataWithFallBack = getPucDataWithFallback(vehicleData, pucData)

  useEffect(() => {
    if (!isFetching) {
      pageEvent(SEGMENT.VIEW_PAGE, {
        ...segmentEventCommonProperties,
        product: commonWidgetConfig?.product?.[PUC_WIDGET],
        phone: phone || userData?.phone,
        registration_number: regNo,
        vehicle_type: pucDataWithFallBack?.vehicle_type,
        mm_name: pucDataWithFallBack?.mm_name,
        previous_policy_expiry_date: pucDataWithFallBack?.previous_policy_expiry_date,
        expiry_date: pucDataWithFallBack?.expiry_date,
      })
    }
  }, [isFetching])

  return (
    <WidgetModal setVehicleData={setVehicleData} setRegNo={setRegNo} setWidgetModal={setWidgetModal} vehicleData={vehicleData} regNo={regNo}>
      {!isFetching ? (
        <div className={isPucExpired ? style.pucActive : style.pucExpired}>
          <div className={style.pucText}>
            {PUC_HEADING}
            <span className={isPucExpired ? style.pucActiveStatus : style.pucExpiredStatus}>
              {isPucExpired ? PUC_DETAIL.isActive : PUC_DETAIL.isExpired}
            </span>
          </div>
          <div className={style.pucDate}>
            {isPucExpired ? PUC_DETAIL.isExpired : PUC_DETAIL.isExpires} on {pucData?.expiry_date || '-'}
          </div>
        </div>
      ) : (
        <PucShimmer />
      )}
      <AppDownloadSection
        regNo={regNo}
        widgetType={PUC_WIDGET}
        KeyFeatures={KeyFeatures}
        segmentEventCommonProperties={segmentEventCommonProperties}
        phone={phone}
        userData={userData}
        vehicleData={vehicleData}
        pucStatus={isPucExpired}
        isPucPage
      />
    </WidgetModal>
  )
}

export default PucWidgetModal
